<template>
  <FullPage>
    <Webview>
      <Header :title="$tp('header.title.setting')" :back="back"></Header>
      <div class="edit_frame _fill">
        <FileUpload :onload="onload" :accept="'image/png,image/jpeg,image/jpg'">
          <div class="image_box _avatar" :class="{default: !imageUrl}">
            <div v-if="imageUrl" class="image" :style="{backgroundImage: `url(${imageUrl})`}"></div>
            <div class="icon"><img src="@img/avatar/edit.svg"></div>
          </div>
        </FileUpload>
        <div class="form">
          <template v-for="(item, key) in form">
            <Control :passData="item" :update="update" :check="check"></Control>
          </template>
        </div>
      </div>
      <div class="wv_button">
        <div class="main_btn _main" @click="submit">儲存</div>
      </div>
    </Webview>
  </FullPage>
</template>

<script>
//api
import { editUserMe } from "@/api/userMe";
import { getImageUploadAuth, uploadImages } from "@/api/image";
//utils
import { formatFloat } from "@u/methods";
export default {
  mixins: [
    require("@mix/form").default,
    require("../mixins/formData_Edit").default
  ],
  data() {
    return {
      avatar: {
        file: undefined,
        preview: undefined
      }
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    imageUrl() {
      return this.avatar.preview || this.userInfo.imageUrl;
    }
  },
  created() {
    this.init();
  },
  methods: {
    back() {
      this.$router.replace({ path: "/setting" });
    },
    async init() {
      await this.$store.dispatch("GetUserInfo");

      this.name = this.userInfo.name;
      this.phoneNum = this.userInfo.phoneNum;
    },
    onload(file) {
      const limitMb = 5;
      const sizeMb = formatFloat(file.size / (1024 * 1024));
      if (sizeMb > limitMb) return MESSAGE("e", this.$tp("warm.failSize", { label: limitMb }));

      this.avatar.file = file;
      const reader = new FileReader();
      reader.onload = e => {
        this.avatar.preview = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    async submit() {
      this.checkAll();
      if (!this.isAllValid) return false;

      const params = {
        name: this.name,
        phoneNum: this.phoneNum
      }
      try {
        if (this.avatar.file) {
          let contentType = this.avatar.file.type;
          const auth = await getImageUploadAuth({ contentType })
          const { imageID, authorizedUrl, fields, url } = auth.data;
          let formData = new FormData();
          for (const [key, value] of Object.entries(fields)) {
            formData.append(key, value);
          }
          formData.append("file", this.avatar.file);
          await uploadImages(authorizedUrl, formData);
          params.images = [{ imageID, url, contentType }];
        }
        await editUserMe(params);
        this.$store.dispatch("GetUserInfo");
        NOTIFICATION("s", this.$tp("slot.success", { label: this.$tp("label.save") }));
      }
      catch (error) {
        NOTIFICATION("e", error?.message || this.$tp("slot.failed", { label: this.$tp("label.save") }));
      }
    }
  }
}
</script>

<style lang="scss" spoced>
.edit_frame {
  padding: 1rem $main_P;
  .image_box {
    @include image-box(3.4rem);
    margin: 0 auto;
    margin-bottom: 1.2rem;
    .icon {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 1rem;
    }
  }
}
</style>